<template>
	<div id="app">
		<link rel="stylesheet" href="https://at.alicdn.com/t/font_1181234_8lyjjp1tur3.css" />
		<transition name="fade" mode="out-in"><router-view></router-view></transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {}
};
</script>

<style lang="scss">
.pad20 {
	width: 95%;
	padding: 10px 20px 20px 20px;
	background: #ffffff;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.pad2 {
	width: 98%;
}
.el-pagination__total {
	margin-left: 14px !important;
}
.el-pagination__jump {
	margin-left: 3px !important;
}
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
	background: #fff !important;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
	background: #fff !important;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.el-pagination.is-background .el-pager li {
	background: #fff !important;
}
.el-pagination.is-background .el-pager li {
	background: #fff !important;
	border: 1px solid transparent;
	font-weight: 400;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.btn_cha {
	background: #069af0 !important;
	color: #ffffff !important;
	box-shadow: 0px 2px 7px 0px rgba(6, 154, 240, 0.21), 0px 2px 4px 0px rgba(6, 154, 240, 0.22);
}
#tab_can {
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.el-pagination.is-background .el-pager li {
	background: #ffffff !important;
	border: 1px solid rgba(232, 232, 232, 1) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
	background: #ffffff !important;
	border: 1px solid #069af0 !important;
	color: #069af0 !important;
}
.pageStyle {
	width: 100%;
	float: left;
	margin-top: 20px;
}
.pageStyle .pages_el {
	float: right;
}
@font-face {
	font-family: 'iconfont'; /* project id 1181234 */
	src: url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.eot');
	src: url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.woff2') format('woff2'),
		url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.woff') format('woff'), url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.ttf') format('truetype'),
		url('//at.alicdn.com/t/font_1181234_8lyjjp1tur3.svg#iconfont') format('svg');
}
body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^='fa'] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^='fa'] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?23d9448b